{
  "de": {
    "item": {
      "deleted": "Gelöschter Inhalt"
    }
  }
}
